import {AllocatableLoadMethod, allocatableLoadMethods} from "@ots-frontend/ots-data";
import {BaseDbCodeSelect, DbCodeSelectProps} from "../base-db-code-select";

type Props = DbCodeSelectProps<AllocatableLoadMethod>;

export const AllocatableLoadMethodSelect = (props: Props) => {
  const {options = allocatableLoadMethods, ...rest} = props;
  return <BaseDbCodeSelect options={options} {...rest} />;
};
